<ng-container *ngIf="timeslot$ | async as timeslot">
  <ng-container *ngIf="personaId$ | async as personaId">

  <button mat-raised-button color="primary" *ngIf="timeslot.personaStateForPersona(personaId)?.canApplyInstructor" (click)="apply(timeslot.id, personaId)">als Trainer registrieren</button>
  <button mat-raised-button color="primary" *ngIf="timeslot.personaStateForPersona(personaId)?.canUnapplyInstructor" (click)="unapply(timeslot.id, personaId)">als Trainer abmelden</button>

  </ng-container>
</ng-container>
